// React
import React from "react";

// Libraries
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";

// Components
import ReplyMessage from "../ReplyMessage";

// Styles
import styles from "./styles.module.css";

const ReplyBar = ({ item, removeReply }) => {
	return (
		<div className={styles.container}>
			<div className={styles.messageContainer}>
				<ReplyMessage item={item} />
			</div>
			<div className={styles.buttonIconContainer} role="button" tabIndex="-1" onClick={removeReply}>
				<Icon name="times circle outline" size="large" />
			</div>
		</div>
	);
};

ReplyBar.propTypes = {
	item: PropTypes.object,
	removeReply: PropTypes.func,
};

export default ReplyBar;
